module.exports = __webpack_public_path__ + "img/nike_logo_en.9131b9ef.svg";